module.exports = __webpack_public_path__ + "static/media/corona3.0d1f30ad.jpeg";